import type { NavigationAction } from "@react-navigation/native";

export const isNavigationAction = (
  item: NavigationAction | (() => void) | undefined
): item is NavigationAction => {
  return (item as NavigationAction)?.type !== undefined;
};

export const isFunction = (value: unknown): value is Function => {
  return typeof value === "function";
};
